<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn icon v-bind="attrs" v-on="on" @click="signOut">
        <v-icon>mdi-power</v-icon>
      </v-btn>
    </template>
    <span>Log out</span>
  </v-tooltip>
</template>

<script>
import Signout from "@/components/Logout/Signout";
import {mapState} from "vuex";

export default {
  name: "LogOut",
  computed: {
    ...mapState("RadStudies", ["studiesList"]),
  },
  methods: {
    async signOut() {
      try {
          await Signout.methods.signOut();
      } catch (error) {
        console.log("Error while logout.");
      }
    },
  },
};
</script>
